import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updatePartnerSingleCommission=({
    commission,
    highCommission
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_PARTNER_SINGLE_COMMISSION_START
    })
    const options={
        url:`${api}/partnerSingleCommissions`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{
            commission,
            highCommission
        }
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_PARTNER_SINGLE_COMMISSION_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_PARTNER_SINGLE_COMMISSION_FAIL,
                payload:getMessage(error)
            }))
}